export const PRIMENG_PT_BR = {
  selectionMessage: '{0} itens selecionados',
  emptySelectionMessage: 'Nenhum item selecionado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  emptyMessage: 'Nenhuma opção disponível',

  // Calendário
  dayNames: [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  today: 'Hoje',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,

  // Botões comuns
  clear: 'Limpar',
  apply: 'Aplicar',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',
  close: 'Fechar',

  // Filtros
  matchAll: 'Coincidir Todos',
  matchAny: 'Coincidir Qualquer',
  addRule: 'Adicionar Regra',
  removeRule: 'Remover Regra',
  accept: 'Sim',
  reject: 'Não',

  // Paginação
  aria: {
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primeira Página',
    lastPageLabel: 'Última Página',
    nextPageLabel: 'Próxima Página',
    previousPageLabel: 'Página Anterior',
    slideNumber: 'Slide {slideNumber}',
  },

  // FileUpload
  chooseLabel: 'Escolher',
  uploadLabel: 'Enviar',
  cancelLabel: 'Cancelar',

  // Mensagens
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',
  passwordPrompt: 'Digite uma senha',

  // Filtros de tabela
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual',
  notEquals: 'Diferente',
  noFilter: 'Sem Filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data antes de',
  dateAfter: 'Data depois de',
};
